//import { MsalAuthProvider, LoginType } from 'react-aad-msal';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID_FRONTEND,
    authority: "https://login.microsoftonline.com/6e93a626-8aca-4dc1-9191-ce291b4b75a1",
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read", "Group.Read.All", "GroupMember.Read.All"]
 //scopes: ["user_impersonation"]
};

//// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: process.env.REACT_APP_ACCESS_API
};

/*
// Options
const options = {
    loginType: LoginType.Popup,
    tokenRefreshUri: window.location.origin + '/auth.html'
}

export const authProvider = new MsalAuthProvider(msalConfig, loginRequest, options)
*/